import React from "react";
import { Box, Button, Heading, Flex } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { TiArrowBackOutline } from "react-icons/ti";

const Header = ({ title, routes }) => {
  const history = useHistory();
  return (
    <Box w="100%" bg="white" mb="1rem" p="1rem">
      <Flex justifyContent={"space-between"} alignItems={"center"}>
        <Heading variant="h1">{title}</Heading>
        <Button
          leftIcon={<TiArrowBackOutline />}
          variant="outline"
          onClick={() => history.goBack()}
        >
          Volver
        </Button>
      </Flex>
    </Box>
  );
};

export default Header;
